import React from 'react';
import { Users } from '../components';
import SimpleHeader from '../components/simple_header';
import { FaPersonBooth, FaPlus } from 'react-icons/fa';
import { MdOutlinePerson } from "react-icons/md";
import { useAuth } from '../contexts/auth.context';

export default function UsersPage(){
    const [open, setOpen] = React.useState(false);
    const [updating, setUpdating] = React.useState(null);

    const listRef = React.useRef<any>();

    const { currentCompany } = useAuth();

    return <>
        <SimpleHeader Icon={MdOutlinePerson} title="Usuários" button={
            !["Cliente", "Agente", "Motorista"].includes(currentCompany?.role?.profile?.title) &&
            { leftIcon: <FaPlus />, title: "Usuário", onClick: () => { setOpen(true) }}
        }  />
        <Users.List ref={listRef} onEdit={user => setUpdating(user)} />
        <Users.Create
            open={open || updating}
            id={updating?._id}
            data={updating ? {
                name: updating.name,
                email: updating.email,
                phone: updating.phone,
                profile: (updating.roles ?? [])[0]?.profile?._id,
            } : null}
            onClose={() => { setOpen(false); setUpdating(null) }} 
            onSave={() => {
                listRef?.current?.refresh();
                setOpen(false);
                setUpdating(null)
            }}
        />
    </>
}
